export default "__VITE_PUBLIC_ASSET__047e5547__"